import React, {Component} from "react";
import {FooterBar, FooterLanguageWrapper} from "./Footer.style";
import FooterLink from "./AcessLink/FooterLink";
import FooterSubLink from "./AcessSubLink/FooterSubLink";
import FooterSocialLink from "./AcessSocialLink/FooterSocialLink";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../sanitize-html.whitelist";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import { LazyLoadImage } from "react-lazy-load-image-component";

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollDistance: 0,
      heightInnerContent: 0,
    };

    this.sectionRef = React.createRef();
    this.innerContentRef = React.createRef();
  }

  componentDidMount() {
    if (this.innerContentRef.current) {
      this.updateHeightInnerContent()
    }
    window.removeEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.updateHeightInnerContent);
    window.addEventListener('load', this.updateHeightInnerContent);
    window.addEventListener('reload', this.updateHeightInnerContent);
    window.addEventListener('orientationchange', this.updateHeightInnerContent);

    this.sectionRef.current?.parentElement.classList.add(`unset__grid`);     
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.heightInnerContent !== this.innerContentRef.current.clientHeight) {
      this.updateHeightInnerContent()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateHeightInnerContent);
    window.removeEventListener('load', this.updateHeightInnerContent);
    window.removeEventListener('reload', this.updateHeightInnerContent);
    window.removeEventListener('orientationchange', this.updateHeightInnerContent);
  }

  updateHeightInnerContent = () => {
    this.setState({ heightInnerContent: this.innerContentRef.current.clientHeight });
  }

  handleScroll = () => {
    const component = this.sectionRef.current;
    if (component) {
      const componentPosition = component.getBoundingClientRect();

      requestAnimationFrame(() => {
          this.setState({ scrollDistance: (Math.round(window.innerHeight-componentPosition.top) / componentPosition.height) * 100});
      });
    }
  }

  render() {
    const {
      logoURL,
      logo,
      altLogo,
      acessLinks,
      acessSubLinks,
      acessSocialLinks,
      rightsText,
      showLanguageNavigation
    } = this.props;

    return (
      <FooterBar ref={this.sectionRef} heightInnerContent={this.state.heightInnerContent} scrollDistance={this.state.scrollDistance}>
        <div className="scroll">
          <div className="scroll-container">
            <div className="footer-scroll"><div className="scroll-indicator"></div></div>
          </div>
        </div>
        <div className="footer__content">
          <section className="footer__elements" ref={this.innerContentRef}>
            <a href={logoURL} rel="canonical">
              <LazyLoadImage className="footer__logo" src={logo} alt={altLogo} />
            </a>
            <nav className="container__links">
              <FooterLink acessLinks={acessLinks} />
            </nav>
            <nav className="container__social">
              <FooterSocialLink acessSocialLinks={acessSocialLinks} />
            </nav>
            <nav className="container__sublinks">
              <FooterSubLink acessSubLinks={acessSubLinks} />
            </nav>
          </section>
          <FooterLanguageWrapper>
            {showLanguageNavigation && <LanguageSelector {...this.props} inFooter/>}
          </FooterLanguageWrapper>
          <hr className="footer__separator" />
          <section
            className="richtext footer__copyrights"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(rightsText, sanitizeWhiteList),
            }}
          />
        </div>
        
      </FooterBar>
    );
  }
}

const FooterHandleErrors = props => {
  return (
      <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The footer component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
          <Footer {...props}/>
      </ErrorBoundary>
  )
}

export default FooterHandleErrors;
